// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"28":"7a259f3f","291":"87ad9df3","297":"b63d0629","386":"680cc625","446":"0c40ba5c","515":"35d54f66","540":"da3c9707","579":"9c6331b9","743":"f3d5e1b2","843":"5b4abbec","994":"df590953"}[chunkId] + ".chunk.js";
};